export const PARLIAMENT_FACTS = {
  "2025-08-08": [
    {
      question: "How is the Speaker chosen?",
      answer:
        "The Speaker is elected by MPs at the first meeting of a new Parliament. The candidates can be existing MPs or other qualified individuals, and the election is decided by a secret ballot if there is more than one nominee.",
    },
    {
      question: "What happens when an MP changes political sides?",
      answer:
        'Under the 2022 "Anti-Hopping Law," an MP who resigns from their party to join another will lose their seat, which triggers a by-election. However, if an MP is expelled by their party, they can keep their seat.',
    },
  ],
  "2025-08-09": [
    {
      question: "What happens when an MP is suspended?",
      answer:
        "A suspended MP is barred from entering the parliamentary chamber and public gallery. The duration of the suspension and other penalties are determined by the House based on the severity of the offense.",
    },
    {
      question: "How much does a Malaysian MP earn?",
      answer:
        "According to the Prime Minister's Office, an MP receives a fixed monthly allowance of RM25,700 and can earn between RM30,000 to RM40,000 per month with other claims and allowances.",
    },
  ],
  "2025-08-10": [
    {
      question: "How many politicians are in the main house?",
      answer:
        "There are 222 Members of Parliament (MPs) in the Dewan Rakyat (House of Representatives), each representing a different part of the country.",
    },
    {
      question: "How are the Senate members chosen?",
      answer:
        "There are 70 senators in total. The King appoints 44 of them, and the remaining 26 are elected by the 13 state legislative assemblies.",
    },
  ],
  "2025-08-11": [
    {
      question: "How big is the Parliament complex?",
      answer:
        "The Parliament complex is roughly 40 acres, which is about the size of 30 football fields.",
    },
    {
      question: "Can the public go inside the Parliament building?",
      answer:
        "Yes! The public can visit the gallery to watch a parliamentary sitting. You just need to follow a strict dress code and protocol.",
    },
  ],
  "2025-08-12": [
    {
      question: "What is the most famous statue near Parliament?",
      answer:
        "The National Monument (Tugu Negara), which honors fallen soldiers, is located nearby and was sculpted by Felix de Weldon, the same artist who created the Iwo Jima Memorial in the U.S.",
    },
    {
      question: 'What is a "parliamentary privilege"?',
      answer:
        "It is a special right that allows MPs to speak freely on any subject during parliamentary debates without facing a lawsuit or other legal action.",
    },
  ],
  "2025-08-13": [
    {
      question: 'What is a "bill"?',
      answer:
        'A "bill" is a fancy name for a new law that is being proposed. If it gets enough votes and the King\'s approval, it becomes an official law, or "Act."',
    },
    {
      question:
        "What is the special staff called that the Serjeant-at-Arms carries?",
      answer:
        "The official in charge of order and security carries a special ceremonial staff called a mace. It is a symbol of the authority of Parliament.",
    },
  ],
  "2025-08-14": [
    {
      question: "Is there a rule about what MPs can wear?",
      answer:
        "Yes, there is a formal dress code. However, on Thursdays, MPs are allowed to wear Malaysian batik shirts to promote local culture.",
    },
    {
      question: 'What is the main job of the "Leader of the Opposition"?',
      answer:
        "The Leader of the Opposition is the main person in charge of the political parties that are not in government. Their job is to hold the government accountable and offer alternative policies.",
    },
  ],
  "2025-08-15": [
    {
      question: "How do new laws get approved by the King?",
      answer:
        'After a bill is passed by Parliament, it is presented to the Yang di-Pertuan Agong (the King) for his official approval and signature. This process is called "Royal Assent."',
    },
    {
      question:
        "Does the person in charge of Parliament have to be an elected politician?",
      answer:
        "No, the Speaker of the House (the person who runs the meetings) can be elected from outside of the group of MPs, as long as they are qualified to be one.",
    },
  ],
  "2025-08-16": [
    {
      question: "How often do they hold a general election?",
      answer:
        "A new general election must be held at least once every five years, or when Parliament is dissolved by the King on the advice of the Prime Minister.",
    },
    {
      question: "Why is the Parliament building on a hill?",
      answer:
        "The building was intentionally placed on a hill to signify its high political and legal importance as the center of the nation's governance.",
    },
  ],
  "2025-08-17": [
    {
      question: 'What is a "parliamentary session"?',
      answer:
        "This is when the MPs meet to do their work. A session can last for several weeks, with the MPs often working long days.",
    },
    {
      question: "How do MPs vote on a new law?",
      answer:
        'Sometimes they just shout "Ayes" or "Noes" and the Speaker decides. But for big decisions, they may have to stand up to be counted or walk into different rooms.',
    },
  ],
  "2025-08-18": [
    {
      question: 'What is the difference between a "bill" and an "Act"?',
      answer:
        'A bill is a proposed law. When the bill is passed by Parliament and approved by the King, it officially becomes an "Act."',
    },
    {
      question: "Is there a special uniform for the King's address?",
      answer:
        "When the Yang di-Pertuan Agong (the King) gives an opening address to Parliament, the MPs, senators, and officials all wear special ceremonial attire for the formal occasion.",
    },
  ],
  "2025-08-19": [
    {
      question: "Is it true that MPs can't just speak their minds?",
      answer:
        "While they have freedom of speech, MPs cannot say anything that questions the special status of the King or certain constitutional provisions, or they may face disciplinary action.",
    },
    {
      question: "What's Malaysia's Parliament officially called?",
      answer:
        "It's just the Parliament of Malaysia (or Parlimen Malaysia if you're feeling official!). Simple, right?",
    },
  ],
  "2025-08-20": [
    {
      question: "Who's the VIP who kicks off every new Parliament session?",
      answer:
        "That would be our very own Yang di-Pertuan Agong, the King! He's like the ultimate opening act.",
    },
    {
      question: "What's the fancy name for the Parliament's \"upper house\"?",
      answer:
        'It\'s the Dewan Negara, which means "Senate." Think of them as the wise elders of Parliament!',
    },
  ],
  "2025-08-21": [
    {
      question: 'And the "lower house" where most of the action happens?',
      answer:
        'That\'s the Dewan Rakyat, or "House of Representatives." This is where your elected MPs hang out!',
    },
    {
      question:
        'How many "reads" does a new law usually get before it\'s official?',
      answer:
        "A bill typically goes through three readings. Like a book, but way more important!",
    },
  ],
  "2025-08-22": [
    {
      question:
        "What's that big, formal event called when Parliament first opens?",
      answer:
        "It's the Royal Address! The King gives a speech, setting the tone for the session.",
    },
    {
      question:
        "Ever wonder how they keep track of every word said in Parliament?",
      answer:
        'They write it all down in the Hansard, the official record. No "he said, she said" here!',
    },
  ],
  "2025-08-23": [
    {
      question:
        'What\'s a "Whip" in Parliament, and do they use an actual whip?',
      answer:
        "Nah, no actual whips! A Whip is an MP who makes sure their party members show up and vote correctly.",
    },
    {
      question: "How old do you have to be to become an MP in Malaysia?",
      answer:
        "You need to be at least 21 years old. Time to start planning your political career!",
    },
  ],
  "2025-08-24": [
    {
      question: "What's that cool symbol on the Speaker's chair?",
      answer:
        "It's the Malaysian Coat of Arms – a powerful symbol of our nation right there!",
    },
    {
      question: "Can an MP just get arrested in the middle of a session?",
      answer:
        'Usually no, thanks to something called "parliamentary privilege." It gives them a bit of immunity to do their job.',
    },
  ],
  "2025-08-25": [
    {
      question: "What color are the seats in the Dewan Rakyat?",
      answer:
        "They're a lovely shade of green! Adds a calming vibe to all those debates, perhaps?",
    },
    {
      question: 'What\'s a "Quorum" in Parliament, and why is it important?',
      answer:
        "It's the minimum number of MPs who must be present for Parliament to actually do business. No quorum, no decisions!",
    },
  ],
  "2025-08-26": [
    {
      question:
        "Who's the super important person who runs the Dewan Rakyat's admin?",
      answer:
        "That's the Clerk of the House! They're like the unsung hero keeping everything running smoothly.",
    },
    {
      question: "How many super-smart Senators are there in the Dewan Negara?",
      answer: "There are 70 of them! That's a lot of wisdom in one room.",
    },
  ],
  "2025-08-27": [
    {
      question: "How long can a Senator serve in the Dewan Negara?",
      answer:
        "They can serve for two terms, with each term lasting three years.",
    },
    {
      question:
        "What happens if there's a tie vote in Parliament? Talk about drama!",
      answer:
        "When votes are tied, the Speaker steps in and casts the deciding vote. Talk about pressure!",
    },
  ],
  "2025-08-28": [
    {
      question:
        'What\'s a "White Paper," and is it just a plain piece of paper?',
      answer:
        "It's actually a government report that explains policy proposals. Not just any paper – a very important one!",
    },
    {
      question: "What's that special staff the Serjeant-at-Arms carries?",
      answer:
        "It's called the Cokmar, and it's a symbol of authority! Pretty cool, huh?",
    },
  ],
  "2025-08-29": [
    {
      question: "What's the big deal about \"Prime Minister's Question Time\"?",
      answer:
        "It's when MPs get to ask the Prime Minister questions directly! It can get pretty lively.",
    },
  ],
};
